import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Search = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 13.5L10.1875 10.1875M10.1875 10.1875C11 9.375 11.5 8.25 11.5 7C11.5 4.5 9.5 2.5 7 2.5C4.5 2.5 2.5 4.5 2.5 7C2.5 9.5 4.5 11.5 7 11.5C8.25 11.5 9.375 11 10.1875 10.1875Z"
        stroke={color}
      />
    </svg>
  ),
)

Search.displayName = 'Search'

Search.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Search
